import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  UnauthContainer, UnauthHeader, UnauthImage, UnauthText, UnauthWrapper,
} from './unauthorizedElements';
import { CarbonButton } from '../../Utils/generalStyles';
import img1 from '../../Images/Unauth/unauth.svg';

const index = () => {
  const navigate = useNavigate();
  return (
    <UnauthContainer>
      <UnauthWrapper>
        <UnauthImage src={img1} alt="unauth" />
        <UnauthHeader>Unauthorized</UnauthHeader>
        <UnauthText>You dont have access to page</UnauthText>
        <CarbonButton colored onClick={() => navigate('/')}>Back to Home</CarbonButton>
      </UnauthWrapper>
    </UnauthContainer>
  );
};

export default index;
